<div class="cald_dialog">
    <div class="cald_header">
      <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
      <h2>{{ 'Admin.CloudIntegration.TranslateTransactionIdLabelDialog.Title' | translate }}</h2>
    </div>
    
    <div class="cald_content p-4 pt-0">
      <cpq-ml-translations 
        [header]="translationHeader" 
        [service]="transactionIdLabelTranslationService"
        (onTranslationFormStatusChange)="onLanguageTranslationFormStatusChanged($event)"></cpq-ml-translations>
    </div>
  
    <div class="form-inline cald_dialog_buttonbar">
      <button type="button" class="btn btn-primary fiori3-btn-primary" [disabled]="isTranslationFormInvalid" (click)="save()">{{ 'Admin.Msg.Save'| translate }}</button>
      <button class="btn btn-tertiary fiori3-btn-tertiary" (click)="cancel()">{{'Admin.Msg.CancelButton'| translate }}</button>
    </div>
  </div>